import { getLadderLabel, isMatchupEvent } from '../services/activityFeedService';

/** Event types that surface rank movement — link to the ladder for that game type. */
const LEADERBOARD_MOMENT_TYPES = new Set(['rank_up', 'overtook_player', 'biggest_mover']);

/**
 * Maps activity_events.metadata.ladder_type to FullLeaderboardPage :gameType param.
 * @param {string|null|undefined} ladderType
 * @returns {'mixed'|'levels-male'|'levels-female'|null}
 */
export function ladderTypeToLeaderboardGameType(ladderType) {
  switch (ladderType) {
    case 'mixed':
      return 'mixed';
    case 'levels_male':
      return 'levels-male';
    case 'levels_female':
      return 'levels-female';
    default:
      return null;
  }
}

/**
 * CTA label + navigation target for a performance/matchup moment card.
 * @returns {{ label: string, destination: string, gameType?: string, seasonId?: string } | null}
 */
export function getActivityMomentCta(event, { currentUser } = {}) {
  if (!event) return null;

  const { event_type, metadata, club_id, season_id, source_session_id } = event;

  if (isMatchupEvent(event_type) && metadata?.opponent_id) {
    return { label: 'View match history', destination: 'match_history' };
  }

  if (event_type === 'personal_best' && club_id) {
    return { label: 'View club performance', destination: 'performance' };
  }

  if (LEADERBOARD_MOMENT_TYPES.has(event_type) && club_id && metadata?.ladder_type) {
    const ladderLabel = getLadderLabel(metadata.ladder_type);
    const gameType = ladderTypeToLeaderboardGameType(metadata.ladder_type);
    if (gameType) {
      return {
        label: `View ${ladderLabel} leaderboard`,
        destination: 'leaderboard',
        gameType,
        seasonId: season_id,
      };
    }
    return { label: 'View leaderboards', destination: 'leaderboard_tab' };
  }

  if (source_session_id && currentUser?.id) {
    return { label: 'View session results', destination: 'session' };
  }

  return null;
}

/**
 * Navigate for a moment card CTA (home + club strips).
 */
export function navigateForActivityMoment(navigate, event, currentUser) {
  const cta = getActivityMomentCta(event, { currentUser });
  if (!cta) return;

  switch (cta.destination) {
    case 'match_history': {
      const params = new URLSearchParams({ opponentId: event.metadata.opponent_id });
      if (event.club_id) params.set('clubId', event.club_id);
      navigate(`/profile/matchups?${params.toString()}`);
      break;
    }
    case 'performance':
      navigate(`/clubs/${event.club_id}?tab=performance`, { state: { fromHome: true } });
      break;
    case 'leaderboard': {
      const qs = cta.seasonId ? `?season=${cta.seasonId}` : '';
      navigate(`/clubs/${event.club_id}/leaderboard/${cta.gameType}${qs}`);
      break;
    }
    case 'leaderboard_tab':
      navigate(`/clubs/${event.club_id}?tab=leaderboard`);
      break;
    case 'session':
      navigate(`/player/${currentUser.id}/session/${event.source_session_id}`, {
        state: { clubId: event.club_id, fromHome: true },
      });
      break;
    default:
      break;
  }
}
